import { inject, observer } from 'mobx-react';
import React from 'react';
import { Card, Grid } from 'telia-front-react';
import LanguageStore from '../stores/LanguageStore';
import MeluChooseParametersCard from './MeluChooseParametersCard';
import { defaultCallsDeviceCount, defaultInternetDeviceCount, getFirstRoamingDataAmountWithAsterisk, getFirstInternetDataWithAsterisk } from './MeluDataUtil';
import MeluSummaryCard from './MeluSummaryCard';
import { observable, runInAction } from 'mobx';

interface SingleDevicePrice {
  price: string;
  roaming: string;
}

export interface InternetPrice {
  price: string;
  pricesPerUser?: number[];
  singleDevice?: SingleDevicePrice;
  showAsterisk: boolean;
  productId?: string;
  roaming: string;
}

export interface Prices {
  infiniteCallsDevicePrice?: string;
  infiniteCallsDeviceProductId?: string;
  internetDevicePrice?: string;
  internetDeviceProductId?: string;
  internetDataPrices?: KeyValue<InternetPrice>;
}

export interface MeluCalculatorProps {
  languageStore?: LanguageStore;
  prices?: Prices;
  showNetflixOfferCard?: boolean;
}

@observer
class MeluCalculator extends React.Component<MeluCalculatorProps> {
  @observable accessor internetDeviceCount = defaultInternetDeviceCount;
  public setInternetDeviceCount = (val: number) => {
    runInAction(() => {
      this.internetDeviceCount = val;
    });
  };
  @observable accessor callsDeviceCount = defaultCallsDeviceCount;
  public setCallsDeviceCount = (val: number) => {
    runInAction(() => {
      this.callsDeviceCount = val;
    });
  };
  @observable accessor internetDataAmount = getFirstInternetDataWithAsterisk(this.props.prices);
  public setInternetDataAmount = (val: number) => {
    runInAction(() => {
      this.internetDataAmount = val;
    });
  };
  @observable accessor roamingDataAmount = getFirstRoamingDataAmountWithAsterisk(this.props.prices);
  public setRoamingDataAmount = (val: string) => {
    runInAction(() => {
      this.roamingDataAmount = val;
    });
  };

  public render() {
    return (
      <Card className="text__margin-double" padding="medium" background="transparent">
        <Grid equalHeight={true} gutter="none">
          <MeluChooseParametersCard
            internetDeviceCount={this.internetDeviceCount}
            setInternetDeviceCount={this.setInternetDeviceCount}
            callsDeviceCount={this.callsDeviceCount}
            setCallsDeviceCount={this.setCallsDeviceCount}
            internetDataAmount={this.internetDataAmount}
            setInternetDataAmount={this.setInternetDataAmount}
            setRoamingDataAmount={this.setRoamingDataAmount}
            prices={this.props.prices}
          />
          <MeluSummaryCard
            internetDeviceCount={this.internetDeviceCount}
            callsDeviceCount={this.callsDeviceCount}
            internetDataAmount={this.internetDataAmount}
            roamingDataAmount={this.roamingDataAmount}
            prices={this.props.prices}
            showNetflixOfferCard={this.props.showNetflixOfferCard}
          />
        </Grid>
      </Card>
    );
  }
}

export default inject('languageStore')(MeluCalculator);
